import React, { useState } from 'react';
import { Product, Region } from '../../types/models';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { X, Save, Search, DollarSign } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
export const PriceAdjustmentPanel: React.FC = () => {
  const {
    user
  } = useAuth();
  const [selectedRegion, setSelectedRegion] = useState<'limpopo' | 'gauteng' | 'all'>('all');
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  // Determine which regions the admin can edit
  const canEditRegion = (region: 'limpopo' | 'gauteng') => {
    // Main admin can edit all regions
    if (user?.adminType === 'main') {
      return true;
    }
    // Regional admins can only edit their own region
    return user?.region === region;
  };
  const handlePriceUpdate = async (productId: string, newPrice: number, region: 'limpopo' | 'gauteng') => {
    // Check permission before updating
    if (!canEditRegion(region)) {
      alert(`You don't have permission to edit prices for ${region}`);
      return;
    }
    try {
      // Update price logic here
      console.log(`Updating product ${productId} price to ${newPrice} for ${region}`);
      // ... existing price update logic ...
    } catch (error) {
      console.error('Price update failed:', error);
    }
  };
  return <div className="bg-white rounded-lg shadow p-6" data-id="element-264">
      <h2 className="text-2xl font-bold mb-6" data-id="element-265">Price Adjustment</h2>

      {/* Region selector - only show if main admin */}
      {user?.adminType === 'main' && <div className="mb-6" data-id="element-266">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-267">
            Select Region
          </label>
          <div className="flex gap-4" data-id="element-268">
            <button onClick={() => setSelectedRegion('all')} className={`px-4 py-2 rounded ${selectedRegion === 'all' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`} data-id="element-269">
              All Regions
            </button>
            <button onClick={() => setSelectedRegion('limpopo')} className={`px-4 py-2 rounded ${selectedRegion === 'limpopo' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`} data-id="element-270">
              Limpopo
            </button>
            <button onClick={() => setSelectedRegion('gauteng')} className={`px-4 py-2 rounded ${selectedRegion === 'gauteng' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`} data-id="element-271">
              Gauteng
            </button>
          </div>
        </div>}

      {/* Regional admin sees only their region */}
      {user?.adminType === 'regional' && <div className="mb-4 p-4 bg-blue-50 rounded" data-id="element-272">
          <p className="text-sm text-blue-800" data-id="element-273">
            You can only edit prices for <strong data-id="element-274">{user.region}</strong> region
          </p>
        </div>}

      {/* Product list with price editing */}
      <div className="space-y-4" data-id="element-275">
        {/* ... existing product list rendering ... */}
      </div>
    </div>;
};